import { withProps } from 'recompose'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor } from 'src/store'

export default withProps(() => ({
  persistor
}))(PersistGate)
